import { useMatches } from 'react-router-dom';

/** Resolve the active project from any level of the data router, including the root. */
export function useActiveProjectId(): string | undefined {
  const matches = useMatches();
  for (let index = matches.length - 1; index >= 0; index--) {
    const { projectId, campaignId } = matches[index].params;
    const id = projectId ?? campaignId;
    if (id) return id;
  }
  return undefined;
}
